<template>
  <div class="w-full h-full relative">
    <div
      class="flex justify-start items-center pt-2 pb-2 pl-1 pr-1 cursor-pointer logo-admin"
      @click="onClickDetailAdmin()"
    >
      <div
        v-if="renderAdmin.profiles.avatars.length !== 0"
        :style="{
          'background-image': `url(${renderAdmin.profiles.avatars[0].meta.url})`,
        }"
        class="rounded-full size-image-small"
      ></div>
      <span class="font-text-bh pl-2 pr-2">{{ renderAdmin.fullname }}</span>
    </div>
    <el-menu default-active="1" class="el-menu-vertical-demo">
      <el-menu-item index="1" class="tab" @click="onLinkFeed()">
        <div class="flex items-center w-full cursor-pointer">
          <img
            src="../../assets/icon_svg/icon-park-solid_home.svg"
            width="30"
            alt=""
          />
          <div class="w-full flex items-center ml-3">
            <span class="font-text-bh"> {{ $t("feed") }}</span>
          </div>
        </div>
      </el-menu-item>

      <el-menu-item index="2" class="tab" @click="onLinkExplore()">
        <div class="flex items-center w-full cursor-pointer">
          <img
            src="../../assets/icon_svg/ri_user-search-fill.svg"
            width="30"
            alt=""
          />
          <div class="w-full flex items-center ml-3">
            <span class="font-text-bh"> Explore </span>
          </div>
        </div>
      </el-menu-item>

      <el-menu-item index="4" class="tab" @click="onLinkEditProfile()">
        <div class="flex items-center w-full cursor-pointer">
          <img src="../../assets/icon_svg/mdi_edit-box.svg" width="30" alt="" />
          <div class="justify-between flex w-full font-semibold items-center">
            <div class="ml-3 w-full flex items-center">
              <span class="font-text-bh">Edit Profile</span>
            </div>
          </div>
        </div>
      </el-menu-item>
      <el-menu-item index="5" class="tab" @click="onLinkSettingProfile()">
        <div class="flex items-center w-full cursor-pointer">
          <img src="../../assets/icon_svg/uiw_setting.svg" width="30" alt="" />
          <div class="w-full flex items-center ml-3">
            <span class="font-text-bh">Settings</span>
          </div>
        </div>
      </el-menu-item>
      <el-menu-item index="6" class="tab" @click="onLinkLikeTopic()">
        <div class="flex items-center w-full cursor-pointer">
          <img
            src="../../assets/icon_svg/ic_like_topic.svg"
            width="30"
            alt=""
          />
          <div class="w-full flex items-center ml-3">
            <span class="font-text-bh">Like & Topic</span>
          </div>
        </div>
      </el-menu-item>

      <el-menu-item index="6" class="tab" @click="onLinkToolImage()">
        <div class="flex items-center w-full cursor-pointer">
          <img
            src="../../assets/icon_svg/ic_like_topic.svg"
            width="30"
            alt=""
          />
          <div class="w-full flex items-center ml-3">
            <span class="font-text-bh">Tool Image</span>
          </div>
        </div>
      </el-menu-item>

      <!-- <el-sub-menu index="7" class="tab"> -->
      <!-- <template #title>
          <div class="flex items-center w-full">
            <img src="../../assets/icon_svg/ic_package.svg" width="25" alt="" />
            <div class="text-base font-semibold ml-3">
              <span class="font-text-bh">Packages</span>
            </div>
          </div>
        </template> -->

      <!-- <el-menu-item class="ml-12" index="7-0" @click="onLinkPackageDefault()"
          >Heart-Connect Package</el-menu-item
        >
        <el-menu-item class="ml-12" index="7-1" @click="onLinkPackagePlus()"
          >Heart-Connect Plus</el-menu-item
        >
        <el-menu-item class="ml-12" index="7-2" @click="onLinkPackageGold()"
          >Heart-Connect Gold</el-menu-item
        >
        <el-menu-item class="ml-12" index="7-3" @click="onLinkPackagePlatinum()"
          >Heart-Connect Platinum</el-menu-item
        >
        <el-menu-item class="ml-12" index="7-4" @click="onLinkTool()"
          >Tool</el-menu-item
        > -->
      <!-- </el-sub-menu> -->
    </el-menu>
    <!--  -->

    <!-- <div class="absolute bottom-16 w-full">
      <div>
        <div class="text-left p-2 font-semibold">Get the app</div>
        <div class="gap-2 grid">
          <div
            class="flex justify-center items-center rounded-xl bg-down-app p-3 hover:bg-stone-300 cursor-pointer"
          >
            <div class="flex items-center gap-2">
              <img src="../../assets/icon_svg/ic_chplay.svg" alt="" />
              <span>Get it on <b>Google Play</b></span>
            </div>
          </div>
          <div
            class="flex justify-center items-center rounded-xl bg-down-app p-3 hover:bg-stone-300 cursor-pointer"
          >
            <div class="flex items-center gap-2">
              <img src="../../assets/icon_svg/ic_apple.svg" alt="" />
              <span>Download on <b>App Store</b></span>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- -->
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "menu-left",

  data() {
    return {
      imageDefault: require("@/assets/icon_svg/image_default.jpg"),
    };
  },

  computed: {
    renderAdmin() {
      return this.$store.state.profileModule.userAdmin;
    },
  },

  mounted() {},

  methods: {
    ...mapActions(["getDetailUser"]),
    onClickDetailAdmin() {
      this.getDetailUser();
      this.$emit("onShowDetailAdmin", true);
    },
    onLinkFeed() {
      localStorage.setItem("valueRouter", "feeds-view");

      this.$router.push({
        path: "/profile/feed",
        query: {
          namePage: "Feed",
        },
      });
    },

    onLinkExplore() {
      localStorage.setItem("valueRouter", "explore-view");

      this.$router.push({
        path: "/profile/explore",
        query: {
          namePage: "Explore",
        },
      });
    },

    onLinkLikeTopic() {
      localStorage.setItem("valueRouter", "like-topic-view");

      this.$router.push({
        path: "/profile/like-topic",
        query: {
          namePage: "Like & Topic",
        },
      });
    },

    onLinkEditProfile() {
      localStorage.setItem("valueRouter", "edit-profile-view");
      this.$router.push({
        path: "/profile/edit-profile",
        query: {
          namePage: "Edit profiles",
        },
      });
    },

    onLinkSettingProfile() {
      localStorage.setItem("valueRouter", "setting-profile-view");
      this.$router.push({
        path: "/profile/setting-profile",
        query: {
          namePage: "Settings",
        },
      });
    },

    onLinkToolImage() {
      localStorage.setItem("valueRouter", "tool");
      this.$router.push({
        path: "/profile/tool",
        query: {
          namePage: "Tool",
        },
      });
    },
  },
};
</script>

<style lang="scss">
.bg-down-app {
  background-color: #51555b;
  color: #ffffff;
  transition: border-color var(0.3s), background-color var(0.3s),
    color var(0.3s);
}
.bg-down-app:hover {
  background-color: #d7d8da;
  color: #000000;
}
</style>
